export default "__VITE_ASSET__BQqUFPBc__"